import apiClient from "./apiClient";

const reportsApi = {
  exportGeneralReport: async () => {
    const response = await apiClient.get("/reports/general", {
      responseType: "blob",
    });
    return response.data;
  },
};

export default reportsApi;
